import React from "react"
import { Button } from "semantic-ui-react";
import CouponInput from "./components/Cart/CouponInput";

export default function DynamicContent( { config } ) {
  if ( !config.module ) return null
  let Module = modules[ config.module ]
  if ( !Module ) return null
  return <div className="">
    <Module config={config}/>
  </div>
}

const modules = {
  "coupon-input": DynamicContentCouponInput
}

function DynamicContentCouponInput( { config } ) {
  return <div className=" pv7-ns pv5  flex flex-column items-center justify-around ">
    <div>
      <div className="tc pv4">
        <h1 className="f0-ns f2 b ">{config.heading}</h1>
        <div className="f4">{config.tagline}</div>
      </div>
      
      <div className="mw5 w-100 center">
        <CouponInput defaultActive defaultValue={config.promo}/>
      </div>
      {/*<pre>{JSON.stringify( config, null, 2 )}</pre>*/}
    </div>
  </div>
}


// WEBPACK FOOTER //
// ./src/DynamicContent.js